import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation } from "react-router-dom";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { Country, State, City } from "country-state-city";
import Select from "react-select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from "sweetalert2";

function Header() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isButtonClicked, setButtonClicked] = useState(false);
  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false); // State variable for country dropdown visibility
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false); // State variable for state dropdown visibility
  const [cityDropdownOpen, setCityDropdownOpen] = useState(false); // State variable for state dropdown visibility

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
    setSelectedState("");
    setSelectedCity("");
  };

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption);
    setSelectedCity("");
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };

  const toggleCountryDropdown = () => {
    setCountryDropdownOpen(!countryDropdownOpen);
  };

  const toggleStateDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(!stateDropdownOpen);
    console.log(!stateDropdownOpen, "stateDropdownOpen");
  };

  const toggleCityDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(false);
    setCityDropdownOpen(!cityDropdownOpen);
    console.log(!cityDropdownOpen, "cityDropdownOpen");
  };

  const toggleCityCloseDropdown = () => {
    setCountryDropdownOpen(false);
    setStateDropdownOpen(false);
    setCityDropdownOpen(false);
  };

  // Fetch the list of countries
  const countryOptions = Country.getAllCountries().map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  // Fetch the list of states based on the selected country
  const stateOptions = selectedCountry
    ? State.getStatesOfCountry(selectedCountry.value).map((state) => ({
        label: state.name,
        value: state.isoCode,
      }))
    : [];

  // Fetch the list of cities based on the selected state
  const cityOptions = selectedState
    ? City.getCitiesOfState(selectedCountry.value, selectedState.value).map(
        (city) => ({
          label: city.name,
          value: city.name,
        })
      )
    : [];

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    who_are_you: "",
    message: "",
    country: "",
    state: "",
    city: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email"),
    phone: Yup.string().required("Mobile is required"),
    who_are_you: Yup.string().required("Please select a Your profession"),
    message: Yup.string(),
  });

  const dataSubmit = async (values) => {
    try {
      // Add the selected country, state, and city to the values object
      values.country = selectedCountry ? selectedCountry.label : "";
      values.state = selectedState ? selectedState.label : "";
      values.city = selectedCity ? selectedCity.label : "";

      const response = await axios.post(
        "https://mahalaxmioil.3waysource.com/api.php",
        values
      );
      console.log(response.data); // Handle the API response as needed
      // Display SweetAlert on success
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Your data submitted successfully",
        showConfirmButton: false,
        timer: 2500,
      });

      // Close the modal
      onCloseModal();
    } catch (error) {
      console.error(error);
    }
  };
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const wrapperStyle = isSticky ? { height: "90px" } : {};

  return (
    <header className="site-header header-style-2 mobile-sider-drawer-menu">
      <div className="top-bar site-bg-primary hide-on-mobile">
        <div className="container">
          {/*Top bar left section start*/}
          <div className="d-flex flex-wrap justify-content-between">
            <div className="aon-topbar-left d-flex flex-wrap">
              <ul className="aon-topbar-info d-flex flex-wrap mx-2">
                <li className="aon-tb-tagline">
                  Offering nutritious range of{" "}
                  <span
                    className="text-primary"
                    style={{
                      marginLeft: "5px",
                      marginRight: "5px",
                      color: "#75b16c !important",
                    }}
                  >
                    {" "}
                    High Quality Cattle Feed{" "}
                  </span>
                  Supplements
                </li>
                <li className="aon-tb-email">
                  <a href="mailto:info@mahalaxmioilmill.com"></a> Email:
                  info@mahalaxmioilmill.com
                </li>
                <li className="aon-tb-phone">
                  {" "}
                  <a href="tel:+917575094646"></a>Phone : +917575094646
                </li>
              </ul>
            </div>
            {/*Top bar right section start*/}
            <div className="aon-topbar-right d-flex flex-wrap">
              <ul className="topbar-social-icons list-unstyled m-0">
                <li>
                  <a
                    href="https://instagram.com/mahalaxmioil?igshid=ZGUzMzM3NWJiOQ=="
                    target="_blank"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/mansukh-bhagat-57a66521a">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </li>
                <li>
                  <a href="https://wa.me/+917575094646">
                    <FontAwesomeIcon icon={faWhatsapp} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="sticky-wrapper" style={wrapperStyle}>
        <div
          className={`sticky-header main-bar-wraper navbar-expand-lg ${
            isSticky ? "is-fixed color-fill" : ""
          }`}
        >
          <div className="main-bar">
            <div className="container clearfix">
              {/*Logo section start*/}
              <div className="logo-header">
                <div className="logo-header-inner logo-header-one">
                  <a href="/">
                    <img src="/images/logo.png" alt="" />
                  </a>
                </div>
              </div>

              <button
                id="mobile-side-drawer"
                data-target=".header-nav"
                data-toggle="collapse"
                type="button"
                className={`navbar-toggler ${
                  isButtonClicked ? "collapsed" : ""
                }`}
                onClick={() => {
                  setMenuOpen(!isMenuOpen);
                  setButtonClicked(!isButtonClicked);
                }}
              >
                <span className="sr-only">Toggle navigation</span>

                {isMenuOpen ? (
                  <FontAwesomeIcon
                    icon={faTimes}
                    style={{ fontSize: "30px" }}
                  />
                ) : (
                  <>
                    <span className="icon-bar icon-bar-first" />
                    <span className="icon-bar icon-bar-two" />
                    <span className="icon-bar icon-bar-three" />
                  </>
                )}
              </button>

              {/* MAIN Vav */}
              <div
                className={`nav-animation header-nav ml-5 navbar-collapse collapse ${
                  isMenuOpen ? "show" : ""
                }`}
              >
                <ul className=" nav navbar-nav">
                  <li
                    className={`has-child ${
                      location.pathname === "/home" ? "current-menu-item" : ""
                    }`}
                    onClick={handleMenuItemClick}
                  >
                    <Link to="/home">Home</Link>
                    {/* <div className="fa fa-angle-right" /> */}
                  </li>
                  <li
                    className={`has-child ${
                      location.pathname === "/product"
                        ? "current-menu-item"
                        : ""
                    }`}
                    onClick={handleMenuItemClick}
                  >
                    <Link to="/product">Products</Link>
                    {/* <a href="javascript:;">Product</a> */}
                    {/* <div className="fa fa-angle-right" /> */}
                  </li>
                  <li
                    className={`has-child ${
                      location.pathname === "/gallary"
                        ? "current-menu-item"
                        : ""
                    }`}
                    onClick={handleMenuItemClick}
                  >
                    <Link to="/gallary">Gallery</Link>
                  </li>
                  <li
                    className={`has-child ${
                      location.pathname === "/about" ? "current-menu-item" : ""
                    }`}
                    onClick={handleMenuItemClick}
                  >
                    <Link to="/about">About Us</Link>
                  </li>

                  <li
                    className={`has-child ${
                      location.pathname === "/contact"
                        ? "current-menu-item"
                        : ""
                    }`}
                    onClick={handleMenuItemClick}
                  >
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
              {/* Header Right Section*/}
              <div className="extra-nav header-2-nav">
                <div className="extra-cell">
                  <div className="cart-add-btn aon-btn-woocart">
                    <span className="cart-add-pic">
                      {/* <FontAwesomeIcon icon={faWhatsapp} /> */}
                      <button
                        className="site-button btn-animate-one hide-on-mobile"
                        onClick={onOpenModal}
                      >
                        Send Inquiry
                      </button>
                      <Modal open={open} onClose={onCloseModal} center>
                        <Formik
                          initialValues={{ initialValues }}
                          validationSchema={validationSchema}
                          onSubmit={(values) => {
                            dataSubmit(values);
                          }}
                        >
                          {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            isSubmitting,
                            /* and other goodies */
                          }) => (
                            <form
                              className="custom-form"
                              onSubmit={handleSubmit}
                            >
                              <h1 className="sml-h1">Enter Your Details</h1>
                              <fieldset>
                                
                                <label htmlFor="name">Name:</label>
                                <input
                                  name="name"
                                  value={values.name}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  id="name"
                                  placeholder="Name *"
                                  type="text"
                                  className={
                                    touched.name && errors.name ? "error" : ""
                                  }
                                />
                                {touched.name && errors.name && (
                                  <p className="error-message">{errors.name}</p>
                                )}

                                <label htmlFor="phone">Mobile:</label>
                                <input
                                  name="phone"
                                  value={values.phone}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  id="phone"
                                  placeholder="Mobile *"
                                  type="tel"
                                  className={
                                    touched.phone && errors.phone ? "error" : ""
                                  }
                                />
                                {touched.phone && errors.phone && (
                                  <p className="error-message">
                                    {errors.phone}
                                  </p>
                                )}

                                <label htmlFor="email">Email:</label>
                                <input
                                  name="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  id="email"
                                  placeholder="Email *"
                                  type="email"
                                  className={
                                    touched.email && errors.email ? "error" : ""
                                  }
                                />
                                {touched.email && errors.email && (
                                  <p className="error-message">
                                    {errors.email}
                                  </p>
                                )}

                                <label htmlFor="who_are_you">
                                  Who Are You:
                                </label>
                                <select
                                  name="who_are_you"
                                  id="who_are_you"
                                  value={values.who_are_you}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  className={
                                    touched.who_are_you && errors.who_are_you
                                      ? "error"
                                      : ""
                                  }
                                >
                                  <option value="">Select</option>
                                  <option value="Farmer">Farmer</option>
                                  <option value="Trader">Trader</option>
                                  <option value="Wholeseller">
                                    Wholeseller
                                  </option>
                                  <option value="Other">Other</option>
                                </select>
                                {touched.who_are_you && errors.who_are_you && (
                                  <p className="error-message">
                                    {errors.who_are_you}
                                  </p>
                                )}

                                <label>Message:</label>
                                <input
                                  name="message"
                                  id="message"
                                  value={values.message}
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  placeholder="Message *"
                                  type="text"
                                  className={
                                    touched.message && errors.message
                                      ? "error"
                                      : ""
                                  }
                                />
                                {touched.message && errors.message && (
                                  <p className="error-message">
                                    {errors.message}
                                  </p>
                                )}
                                <label>Country</label>
                                <Select
                                  options={countryOptions}
                                  value={selectedCountry}
                                  onChange={handleCountryChange}
                                  onMenuOpen={toggleCountryDropdown}
                                  onMenuClose={toggleCountryDropdown}
                                />

                                <label>State</label>
                                <Select
                                  options={stateOptions}
                                  value={selectedState}
                                  onChange={handleStateChange}
                                  isDisabled={!selectedCountry}
                                  onMenuOpen={toggleStateDropdown}
                                  onMenuClose={toggleStateDropdown}
                                />

                                <label>City</label>
                                <Select
                                  options={cityOptions}
                                  value={selectedCity}
                                  onChange={handleCityChange}
                                  isDisabled={!selectedState}
                                  onMenuOpen={toggleCityDropdown}
                                  onMenuClose={toggleCityCloseDropdown}
                                />
                              </fieldset>

                              <p
                                style={{
                                  color: "red",
                                  margin: "20px",
                                  marginTop: "0px",
                                }}
                              ></p>

                              {!countryDropdownOpen &&
                                !stateDropdownOpen &&
                                !cityDropdownOpen && (
                                  <button
                                    onClick={handleSubmit}
                                    className="site-button-secondry btn-animate-one"
                                  >
                                    Send Inquiry
                                  </button>
                                )}
                            </form>
                          )}
                        </Formik>
                      </Modal>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
